<template>
  <div class="card-contenu">
    <div
      v-if="hasSousPostes && !estMobile"
      class="d-flex justify-end lien-deplier"
    >
      <a
        class="action texte-gris-fonce"
        @click="basculerTout"
      >{{ toutEstDeplie ? 'Tout replier' : 'Tout déplier' }}</a>
    </div>
    <div
      v-if="!estMobile"
      class="d-flex justify-end entete-colonnes"
    >
      <div class="texte texte-gris-fonce element">
        {{ libelleUnite }}
      </div>
      <div
        v-if="hasEvolution"
        class="texte texte-gris-fonce element"
      >
        Evolution
      </div>
      <div class="texte texte-gris-fonce element pl-6">
        Groupe
      </div>
    </div>
    <v-divider v-if="!estMobile" />

    <LigneRestitution
      v-for="bloc in blocs"
      :key="bloc.cle"
      ref="lignes"
      :libelle="bloc.libelle"
      :champ="bloc.champ"
      :evolution="bloc.evolution"
      :valeurs-evolution="bloc.valeursEvolution"
      :champ-groupe="bloc.champGroupe"
      :unite="unite"
      :has-evolution="hasEvolution"
      :hausse-favorable="hausseFavorable"
      :sous-postes="bloc.sousPostes"
    />

    <LigneRestitution
      v-if="champTotal != null"
      :libelle="libelleTotal"
      :champ="champTotal"
      :evolution="evolutionTotal"
      :valeurs-evolution="valeursEvolutionTotal"
      :champ-groupe="champTotalGroupe"
      :unite="unite"
      :has-evolution="hasEvolution"
      :hausse-favorable="hausseFavorable"
      est-un-total
    />
  </div>
</template>
<script>

import LigneRestitution from './ligne-restitution.vue'
import { UNITE_TONNE, UNITE_HECTARE } from '@/utils/restitution'

export default {
  name: 'SectionRestitution',
  components: { LigneRestitution },
  props: {
    blocs: {
      type: Array,
      default: () => []
    },
    champTotal: {
      type: Object,
      default: null
    },
    evolutionTotal: {
      type: Number,
      default: null
    },
    valeursEvolutionTotal: {
      type: Object,
      default: () => ({})
    },
    hausseFavorable: {
      type: Boolean,
      default: true
    },
    champTotalGroupe: {
      type: Object,
      default: undefined
    },
    libelleTotal: {
      type: String,
      default: 'Total'
    },
    unite: {
      type: String,
      default: UNITE_TONNE
    },
    hasEvolution: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toutEstDeplie: false
    }
  },
  computed: {
    estMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    libelleUnite () {
      return this.unite === UNITE_HECTARE ? '€/ha' : '€/t'
    },
    hasSousPostes () {
      return this.blocs.some((bloc) => bloc.sousPostes && bloc.sousPostes.length > 0)
    }
  },
  methods: {
    basculerTout () {
      this.toutEstDeplie = !this.toutEstDeplie
      const lignes = this.$refs.lignes || []
      lignes.forEach((ligne) => (this.toutEstDeplie ? ligne.deplier() : ligne.replier()))
    }
  }
}
</script>
<style lang="scss" scoped>
.card-contenu {
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid white;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.10);
  padding: 16px 24px 24px 24px;
}

.entete-colonnes {
  width: 100%;
  box-sizing: border-box;
  height: 25px;
  margin-top: 16px;
  margin-bottom: 8px;
  padding-left: 16px;
  align-items: flex-end;

  .element {
    width: 112px;
    height: 25px;
  }
}

.lien-deplier {
  width: 100%;
  box-sizing: border-box;
  padding-right: 16px;

  a {
    cursor: pointer;
    text-decoration: underline;
    color: #8A8A89;
  }
}
@media (max-width: 960px) {
  .card-contenu {
    width: 100%;
    padding: 8px;
    border-radius: 0 0 16px 16px;
    box-shadow: none;
    border-top-color: #D7D8D6;
  }
}
</style>
